import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import React from 'react';
import { selectRptReportType } from 'store/remote/selectors';
import { ReportEnum } from 'types/Reports';
import { useSelector } from 'hooks/useSelector';
import { Filter as ReportCheckScheduleFilterModal } from './Reports/ReportCheckSchedule/Filter';
import { Filter as ReportCheckCompletedFilterModal } from './Reports/ReportCheckCompleted/Filter';
import { Filter as ReportCheckStatusFilterModal } from './Reports/ReportCheckStatus/Filter';
import { Filter as ReportElementsFilterModal } from './Reports/ReportElements/Filter';
import { Filter as ReportAssetsFilterModal } from './Reports/ReportAssets/Filter';

export const ReportsFilterModal: React.FC<
  ModalScreenProps<ModalScreens.ReportsFilterModal>
> = ({
  route: {
    params: { reportKey },
  },
}) => {
  const reportType = useSelector((state) =>
    selectRptReportType(state, reportKey),
  )!;

  if (reportType === ReportEnum.checkschedule) {
    return <ReportCheckScheduleFilterModal reportKey={reportKey} />;
  }
  if (reportType === ReportEnum.checkscompleted) {
    return <ReportCheckCompletedFilterModal reportKey={reportKey} />;
  }
  if (reportType === ReportEnum.checkstatus) {
    return <ReportCheckStatusFilterModal reportKey={reportKey} />;
  }
  if (reportType === ReportEnum.elements) {
    return <ReportElementsFilterModal reportKey={reportKey} />;
  }
  if (reportType === ReportEnum.assets) {
    return <ReportAssetsFilterModal reportKey={reportKey} />;
  }

  return null;
};
